import cogoToast from 'cogo-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import {
  recalculateSimulationBySessionId,
  SchemaRecalculateAnvaSimulationCmd,
} from 'wg-api-sdk';

import { wgApiSdk } from '../../../../../app/src/features/api/wgApi';

interface PatchParams {
  sessionId: string;
  payload: SchemaRecalculateAnvaSimulationCmd;
}

const postRecalculateSimulation = ({ payload, sessionId }: PatchParams) =>
  recalculateSimulationBySessionId(
    {
      body: payload,
      params: {
        query: {},
        path: {
          session_id: sessionId,
        },
      },
    },
    wgApiSdk,
  );

export const usePostRecalculateSimulation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation(postRecalculateSimulation, {
    onSuccess: () => {
      queryClient.invalidateQueries([
        'parties',
        'insurance-policy-packages',
        'simulations',
      ]);
      queryClient.invalidateQueries([
        'parties',
        'insurance-policies',
        'simulations',
      ]);
    },
    onError: () => {
      cogoToast.error(t('DASHBOARD_ERROR-POPUP_TITLE'));
    },
  });
};
